// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"18f2e027","787":"cda612ba","960":"a5c10e4e","998":"9a659f12"}[chunkId] + ".chunk.js";
};